/**
 * Prefer durable blob URLs (no SAS) for company file fields in scoping attributes.
 */

export function persistableBlobUrlFromCompanyUpload(data) {
  if (!data || typeof data !== "object") return "";
  if (typeof data.blobUrl === "string" && data.blobUrl.trim()) return data.blobUrl.trim();
  const url = typeof data.url === "string" ? data.url.trim() : "";
  if (!url) return "";
  try {
    const u = new URL(url);
    if (u.hostname.endsWith(".blob.core.windows.net")) return `${u.origin}${u.pathname}`;
  } catch {
    /* ignore */
  }
  const q = url.indexOf("?");
  return q === -1 ? url : url.slice(0, q);
}

/** Strip SAS query from Azure blob URLs when normalizing stored profile values. */
export function durableBlobUrlIfAzure(logo) {
  const s = String(logo || "").trim();
  if (!s) return "";
  try {
    const u = new URL(s);
    if (u.hostname.endsWith(".blob.core.windows.net")) return `${u.origin}${u.pathname}`;
  } catch {
    /* ignore */
  }
  return s;
}

/**
 * Commandment VIII — resolve the client company's logo URL from data the project fetch already
 * carries (`project.profile.companyLogo`, set during Organizational Setup's "Import client
 * branding" step; falls back to the `companyLogo` scoping attribute for older profiles). No
 * network call — every renderer that already receives `project` can call this directly, same
 * source `CompanyProfileDocument.jsx` / `OrganizationalSetup.jsx` already read from.
 */
export function resolveCompanyLogoUrl(project) {
  const profile = (project && project.profile) || {};
  if (typeof profile.companyLogo === "string" && profile.companyLogo.trim()) {
    return durableBlobUrlIfAzure(profile.companyLogo.trim());
  }
  const attrs = Array.isArray(profile.attributes) ? profile.attributes : [];
  const attr = attrs.find((a) => a && a.key === "companyLogo");
  const val = attr && typeof attr.value === "string" ? attr.value.trim() : "";
  return val ? durableBlobUrlIfAzure(val) : "";
}
